Namespace 'Monitoring.Views.SocialContents'

class Monitoring.Views.SocialContents.SessionsView extends Backbone.View
  template: JST['backbone/templates/monitoring/sessions/sessions']
  el: 'body'

  events :
    'click #new_session': '_addNewTab'
    'mouseleave li.session' : 'onMouseLeaveSession'

  initialize: (@options = {}) ->
    @topics = @options.topics
    @defaultCharts = @options.defaultCharts
    @dashboard_default_mode = @options.dashboard_default_mode
    @sessions = @options.sessions
    @tabs = []
    @currentTabIndex = undefined
    @scrollingView = new Customer.Tabs.TabScrollingView()
    @eventAggregator.bind('clickOnTab', @_changeCurrentTab)
    @eventAggregator.bind('clickOnMinimizeTab', @_minimizeTab)
    @eventAggregator.bind('changeStateOnServer', @_changeStateOnServer)
    @eventAggregator.bind('clickOnCloneDashboard', @_cloneDashboard)
    @eventAggregator.bind('clickOnRestoreSession', @_restoreSession)
    @eventAggregator.bind('clickOnRemoveSession', @_removeSession)
    @eventAggregator.bind('clickOnMinimizeAndRemoveSession', @_removeNewSession)
    @eventAggregator.bind('removeAllSessions', @_removeAllSessions)
    @eventAggregator.bind('sessionListChange', @_updateSessions)
    @eventAggregator.bind('replaceSession', @_replaceSession)
    @eventAggregator.bind('currentSessionNameObtained', @_finishRender)
    @eventAggregator.bind('addNewTab', @_addNewTab)
    @eventAggregator.bind('cloneDashboardAndShareSession', @_cloneDashboardAndShareSession)

  render: (options = {}) ->
    defaultOptions = {
      cameFromModerationDashboard: false
    }
    options = $.extend({}, defaultOptions, options)

    @$el.find('#tabs').before(@template())
    for session in @sessions
      if not session.minimized
        @_addNewTabFromExistingSession(session, options)
    if @tabs.length != 0
      @_getCurrentSessionNameAndContinue()
      @$el.find('#content').find('.dashboard').hide()
    else
      @_addNewTab()

    @$el.find('#tabs-wrapper').append(@scrollingView.render().el)
    @scrollingView.setScrollableElement(@$el.find('#main-header #tabs'))
    @

  _getCurrentSessionNameAndContinue: =>
    $.ajax
      url: '/monitoring/sessions/current_session_of_user',
      type: 'GET',
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      success: @_triggerCurrentSessionObtained

  _triggerCurrentSessionObtained: (response) =>
    @eventAggregator.trigger('currentSessionNameObtained', response.current_session_name)

  _getSessionIndexFromName: (sessionName) ->
    sessionNames = @tabs.map( (session) -> session.name )
    sessionIndex = sessionNames.indexOf(sessionName)
    return sessionIndex

  _finishRender: (currentSessionName) =>
    currentSessionIndex = @_getSessionIndexFromName(currentSessionName)
    currentSessionIndex = 0 if currentSessionIndex < 0
    @_changeCurrentTab(@tabs[currentSessionIndex])

  _replaceSession: (searchQuery) =>
    uuid = searchQuery.get('uuid')
    @_cloneDashboard(searchQuery)
    @_destroyTab(@_searchExistingTabForSession(uuid))

  _cloneDashboard: (searchQuery) =>
    query = searchQuery.deepCopy()
    if query.get('analysisMode')
       query.set('analysisMode', false)
       query.set('exploreMode', true)

    if @tabs[@currentTabIndex] != undefined
      isSurveyDashboard = @tabs[@currentTabIndex].sessionMode == 'survey'
    else if @tabs[0] != undefined
      isSurveyDashboard = @tabs[0].sessionMode == 'survey'
    else
      isSurveyDashboard = false

    uuid = Monitoring.Models.RandomStringGenerator.generateNewUuid()
    if isSurveyDashboard
      dashboard = new Monitoring.Views.SocialContents.ClonedSurveyDashboardView({
        topics: @topics
        defaultCharts: @defaultCharts?.slice()
        uuid: uuid
        visualization: @options.visualization
        availableChannelsByProvider: @options.availableChannelsByProvider
        submodesPermissions: @options.submodesPermissions
        searchQuery: query
      })
    else
      dashboard = new Monitoring.Views.SocialContents.ClonedDashboardView({
        topics: @topics
        defaultCharts: @defaultCharts?.slice()
        uuid: uuid
        visualization: @options.visualization
        availableChannelsByProvider: @options.availableChannelsByProvider
        submodesPermissions: @options.submodesPermissions
        searchQuery: query
      })

    tabName = I18n.t('monitoring.dashboard.session.tab.placeholder')
    if query.get('show_share_session')
      tabName = searchQuery.get('name')

    dashboard.rename(tabName)
    @_addNewTabFromDashboard(dashboard, tabName)

  _addNewTab: (event) =>
    event.preventDefault() if event
    uuid = Monitoring.Models.RandomStringGenerator.generateNewUuid()
    @_addNewTabFromDashboard @_newTabDashboardView(uuid)

  _newTabDashboardView: (uuid) ->
    new Monitoring.Views.SocialContents.DashboardView @_newTabDashboardViewOptions(uuid)

  _newTabDashboardViewOptions: (uuid) ->
    $.extend {},  @_commonDashboardViewOptions(),
      sessionList: @sessions
      uuid: uuid
      sessionSharingData:
        uuid: uuid
        edit: false
        title: ''
        url: ''

  _commonDashboardViewOptions: ->
    topics: @topics
    defaultCharts: @defaultCharts?.slice()
    defaultMode: @dashboard_default_mode
    visualization: @options.visualization
    availableChannelsByProvider: @options.availableChannelsByProvider
    submodesPermissions: @options.submodesPermissions

  _addNewTabFromDashboard: (dashboard, tabName=null) ->
    tabName = I18n.t('monitoring.dashboard.session.tab.placeholder') if !tabName
    sessionTab = new Monitoring.Views.SocialContents.SessionTabView(name: tabName, dashboard: dashboard, sessionsView: this)
    sessionTab._renameTooltip(tabName)
    @_bindEvents(dashboard, sessionTab)
    @_createNewTab(sessionTab)
    @_changeCurrentTab(sessionTab)

  _addNewTabFromExistingSession: (session, options = {}) ->
    dashboard = @_existingSessionDashboardView(session, options)
    sessionTab = new Monitoring.Views.SocialContents.SessionTabView
      name: session.name
      dashboard: dashboard
      sessionsView: @
      session: session
    sessionTab._renameTooltip(session.name)
    @_bindEvents(dashboard, sessionTab)
    @_createNewTab(sessionTab)

  _existingSessionDashboardView: (session, options) ->
    new Monitoring.Views.SocialContents.DashboardView(
      $.extend {}, options, @_commonDashboardViewOptions(), session: session
    )

  _bindEvents: (dashboard, sessionTab) ->
    sessionTab._renameTooltip(sessionTab.name)
    dashboard.bind('firstSearch', sessionTab.rename, sessionTab)
    dashboard.bind('restoreFromServer', @_restoreFromServer)
    dashboard.bind('totalChanges', (total) => sessionTab.updateCount(total))

  _createNewTab: (sessionTab) ->
    @tabs.push(sessionTab)
    @$el.find('#tabs').append(sessionTab.render().el)
    # We must append the dashboard element before rendering it to get Chosen to work!
    @$el.find('#content').append(sessionTab.dashboard.el)
    sessionTab.dashboard.bind('destroyFromRestore', => @_destroyTab(sessionTab))
    sessionTab.dashboard.render()

  _changeCurrentTab: (sessionTab) =>
    for tab in @tabs
      tab.deactivate()
    @currentTabIndex = @tabs.indexOf(sessionTab)
    @_updateCurrentSession(sessionTab.name) if sessionTab.name != I18n.t('monitoring.dashboard.session.tab.placeholder')
    try
      @tabs[@currentTabIndex].activate()
      @showCurrentTab()
    catch error
      # happens when creating My History session when no other sessions exist
      # it is harmless, the only problem is visual and is fixed with the following line
      $('li.session').addClass('active')
    @scrollingView.scrollTo(sessionTab.$el)

  _updateCurrentSession: (sessionName) =>
    $.ajax
      url: '/monitoring/sessions/current_session_of_user',
      type: 'PUT',
      data: { current_session: sessionName }

  showCurrentTab: ->
    @$el.find('#content').find('.dashboard').hide()
    @tabs[@currentTabIndex].dashboard.$el.show()

  _minimizeTab: (sessionTabOrUuid) =>
    sessionTab = if typeof sessionTabOrUuid is 'string'
      @_searchExistingTabForSession(sessionTabOrUuid)
    else
      sessionTabOrUuid
    @_changeStateOnServer(sessionTab.getUuid(), 'minimized', true, => @eventAggregator.trigger('sessionListChange'))
    @_destroyTab sessionTab

  _destroyTab: (sessionTab) ->
    sessionTabIndex = @tabs.indexOf(sessionTab)
    currentActiveTab = @tabs[@currentTabIndex]
    @tabs.splice(sessionTabIndex, 1);

    if @tabs.length == 0
      @_addNewTab()
      @currentTabIndex = undefined
    else
      if sessionTab == currentActiveTab
         @currentTabIndex = if @currentTabIndex == 0 then @currentTabIndex else @currentTabIndex - 1
         @tabs[@currentTabIndex].activate()
         @showCurrentTab()
      else
        @currentTabIndex = @tabs.indexOf(currentActiveTab)

    sessionTab.destroy()

  _changeStateOnServer: (uuid, key, newState, onSuccess) ->
    onSuccess = onSuccess || ->
    $.ajax
      url: '/monitoring/dashboard/change_session_state',
      type: 'POST',
      data: { uuid: uuid, attribute_key: key, attribute_value: newState }
      success: onSuccess

  _searchExistingTabForSession: (uuid) ->
    _.find @tabs, (tab) ->
      tab.getUuid() == uuid

  _removeSession: (session) =>
    tab = @_searchExistingTabForSession session.uuid
    if tab
      @_destroyTab tab
    $.ajax
      url: "/monitoring/sessions/#{session.uuid}.json",
      type: 'DELETE',
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      success: =>
        @eventAggregator.trigger('sessionListChange')

  _removeAllSessions: =>
    @_destroyAllTabs()
    @_deleteAllSessionRecords()

  _destroyAllTabs: ->
    length = @tabs.length
    while (length-- > 0)
      @_destroyTab(@tabs[length])

  _deleteAllSessionRecords: ->
    $.ajax
      type: 'POST'
      url: '/monitoring/sessions/dashboard_sessions/delete_all'
      data: {}
      success: @_triggerSessionListChange

  _triggerSessionListChange: =>
    @eventAggregator.trigger('sessionListChange')

  _removeNewSession: (session_tab) =>
    uuid = session_tab.getUuid()
    $.ajax
      type: 'GET'
      url: '/monitoring/sessions/dashboard_sessions/get_by_uuid'
      contentType: 'application/json; charset=utf-8'
      dataType: 'json'
      data:
        uuid: session_tab.getUuid()
      success: (session) =>
        @_removeSession(session)

  _restoreSession: (session, callback) =>
    tab = @_searchExistingTabForSession session.uuid
    if tab
      @_changeCurrentTab tab
    else
      @_addNewTabFromExistingSession session
      @_changeCurrentTab @tabs[@tabs.length-1]
    callback()

  _restoreFromServer: (dashboard) ->
    $.ajax
      url: "/monitoring/sessions/#{dashboard.session.uuid}.json",
      type: 'GET',
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      success: (session) =>
        dashboard.searchQuery = undefined
        dashboard.changeSession(session)
        dashboard.doNewSearch()

  _updateSessions: =>
    $.ajax
      url: '/monitoring/sessions/current_sessions',
      type: 'GET',
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      success: @_updateSessionLists

  _updateSessionLists: (response) =>
    return unless @_shouldUpdateSessions(response)
    @sessions = response.sessions
    tab.dashboard.updateSessionList(@sessions) for tab in @tabs

  _shouldUpdateSessions: (response) ->
    response.sessions? and (not @sessions.timestamp or @sessions.timestamp < response.timestamp)

  onMouseLeaveSession: (event) ->
    event.stopPropagation()
    $(event.target).find('.dropdown').removeClass('open')

  _cloneDashboardAndShareSession: ({ query, name }) =>
    query.set('show_share_session', true)
    query.set('name', name)
    @_cloneDashboard(query)
